import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import PdfForm from '../PdfForm'
import ShareFrom from '../ShareForm'
import Disclaimer from '../Disclaimer'
import X46MK2TransomConfiguratorImage from './X46MK2TransomConfiguratorImage'
import ImageScrubber from '../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView09ImageOptions } from './views/ExteriorView09'
import { interiorView10ImageOptions } from './views/InteriorView10'

class X46MK2Summary extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  render () {
    let imageOptions = exteriorView09ImageOptions

    let image = (
      <ImageScrubber
        images={[
          <X46MK2TransomConfiguratorImage
            key='exterior'
            colorMultiplier={0.75}
            name={this.props.configuration.transom.Name}
            port={this.props.configuration.transom.Port}
            transomSize={{ width: 2700, height: 660 }}
            transform={[
              0.115068, 0.02023, 0, 5.6e-5, 0.005703, 0.102139, 0, 6.6e-6, 0, 0,
              1, 0, 689.554908, 363.402227, 0, 1
            ]}
            boat='X46MK2'
            configuration={this.props.configuration.exterior}
            options={imageOptions}
          />,
          <X46MK2InteriorConfiguratorImage
            key='interior'
            boat='X46MK2'
            configuration={this.props.configuration.interior}
            options={interiorView10ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption style={{ position: 'relative' }}>
          <h1>
            <Trans defaults='Summary' />
          </h1>
          <h2>
            <Trans defaults='Congratulations!' />
          </h2>
          <p>
            <Trans defaults='You have now configured the basics of an <strong>X4<sup>6</sup></strong>. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' />
          </p>

          <PdfForm
            boat='x46mk2'
            country={this.props.country}
            countries={this.props.countries}
            configuration={this.props.configuration}
            code={this.props.code}
          />

          <ShareFrom
            configuration={this.props.configuration}
            boat='x46mk2'
            code={this.props.code}
          />

          <Disclaimer />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Summary)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Summary.js